tuduno.ui.form.ControlMultiSelectList = class ControlMultiSelectList extends (
	tuduno.ui.form.ControlData
) {
	static trigger_change_on_input_event = false;
	make_input() {
		let template = `
			<div class="multiselect-list dropdown">
				<div class="form-control cursor-pointer input-xs" data-toggle="dropdown" tabindex=0>
					<div class="status-text ellipsis"></div>
				</div>
				<ul class="dropdown-menu">
					<li class="dropdown-input-wrapper">
						<input type="text" class="form-control input-xs">
					</li>
					<div class="selectable-items">
					</div>
					<li class="d-flex justify-content-end">
						<button class="btn btn-secondary btn-xs select-all-options text-nowrap mr-2">
							${__("Select All")}
						</button>
						<button class="btn btn-primary btn-xs clear-selections text-nowrap">
							${__("Clear All")}
    					</button>
					</li>
				</ul>
			</div>
		`;

		this.$list_wrapper = $(template);
		this.$input = $("<input>");
		this.input = this.$input.get(0);
		this.has_input = true;
		this.$list_wrapper.prependTo(this.input_area);
		this.$filter_input = this.$list_wrapper.find("input");
		this.values = [];
		this._options = [];
		this._selected_values = [];
		this.highlighted = -1;
		this.$list_wrapper.on("click", ".dropdown-menu", (e) => {
			e.stopPropagation();
		});
		this.$list_wrapper.on("click", ".clear-selections", (e) => {
			this.clear_all_selections();
		});
		this.$list_wrapper.on("click", ".select-all-options", (e) => {
			this.select_all_options();
		});
		this.$list_wrapper.on("click", ".selectable-item", (e) => {
			let $target = $(e.currentTarget);
			this.toggle_select_item($target);
		});

		// open dropdown on tab focus
		const $toggle = this.$list_wrapper.find('[data-toggle="dropdown"]');
		let focus_triggered_by_mouse = false;
		$toggle.on("mousedown", () => {
			focus_triggered_by_mouse = true;
		});
		$toggle.on("focus", () => {
			if (focus_triggered_by_mouse) {
				focus_triggered_by_mouse = false;
				return;
			}
			$toggle.dropdown("show");
		});

		// prevent input text focus loss when clicking items or buttons
		this.$list_wrapper.on(
			"mousedown",
			".selectable-item, .select-all-options, .clear-selections",
			(e) => {
				e.preventDefault();
			}
		);

		this.$list_wrapper.on(
			"input",
			"input",
			tuduno.utils.debounce((e) => {
				this.set_options().then(() => {
					let txt = e.target.value;
					let filtered_options = this._options.filter((opt) => {
						let match = false;
						if (this.values.includes(opt.value)) {
							return true;
						}
						match =
							Awesomplete.FILTER_CONTAINS(opt.label, txt) ||
							Awesomplete.FILTER_CONTAINS(opt.value, txt) ||
							Awesomplete.FILTER_CONTAINS(opt.description, txt);

						return match;
					});
					let options = this._selected_values
						.concat(filtered_options)
						.uniqBy((opt) => opt.value);
					this.set_selectable_items(options);
				});
			}, 300)
		);
		this.$list_wrapper.on("keydown", "input", (e) => {
			if (e.key === "ArrowDown") {
				this.highlight_item(1);
			} else if (e.key === "ArrowUp") {
				this.highlight_item(-1);
			} else if (e.key === "Enter") {
				if (this._$last_highlighted) {
					this.toggle_select_item(this._$last_highlighted);
					return false;
				}
			}
		});

		this.$list_wrapper.on("keydown", (e) => {
			if ($(e.target).is("input")) {
				return;
			}
			if (e.key === "Backspace") {
				this.set_value([]);
			}
		});

		this.$list_wrapper.on("show.bs.dropdown", () => {
			this.set_options().then(() => {
				if (!this._selected_values || !this._selected_values.length) {
					this._selected_values = this.process_options(this.values);
				}
				this._options = this._selected_values
					.concat(this._options)
					.uniqBy((opt) => opt.value);
				this.set_selectable_items(this._options);
				this.$filter_input.trigger("focus");
			});
		});

		this.set_input_attributes();
	}

	set_input_attributes() {
		this.$list_wrapper
			.attr("data-fieldtype", this.df.fieldtype)
			.attr("data-fieldname", this.df.fieldname);

		this.set_status(this.get_placeholder_text());

		if (this.doctype) {
			this.$list_wrapper.attr("data-doctype", this.doctype);
		}
		if (this.df.input_css) {
			this.$list_wrapper.css(this.df.input_css);
		}
		if (this.df.input_class) {
			this.$list_wrapper.addClass(this.df.input_class);
		}
	}

	clear_all_selections() {
		this.values = [];
		this._selected_values = [];
		this.update_status();
		this.set_selectable_items(this._options);
		this.parse_validate_and_set_in_model("");
	}

	select_all_options() {
		this.values = this._options.map((opt) => opt.value);
		this._selected_values = this._options.slice();
		this.update_status();
		this.set_selectable_items(this._options);
		this.parse_validate_and_set_in_model("");
	}

	toggle_select_item($selectable_item) {
		$selectable_item.toggleClass("selected");
		let value = decodeURIComponent($selectable_item.data().value);

		if ($selectable_item.hasClass("selected")) {
			this.values = this.values.slice();
			this.values.push(value);
		} else {
			this.values = this.values.filter((val) => val !== value);
		}
		this.update_selected_values(value);
		this.parse_validate_and_set_in_model("");
		this.update_status();
	}

	set_value(value) {
		if (!value) return Promise.resolve();
		this._selected_values = [];
		if (typeof value === "string") {
			value = [value];
		}
		//Unselect old values
		this.values.forEach((value) => {
			this.$list_wrapper
				.find(`.selectable-item[data-value=${CSS.escape(value)}]`)
				.toggleClass("selected");
		});
		this.values = value;
		this.values.forEach((value) => {
			this.update_selected_values(value);
			//Select new values
			this.$list_wrapper
				.find(`.selectable-item[data-value=${CSS.escape(value)}]`)
				.toggleClass("selected");
		});
		this.parse_validate_and_set_in_model("");
		this.update_status();
		return Promise.resolve();
	}

	update_selected_values(value) {
		this._selected_values = this._selected_values || [];
		let option = this._options
			.concat(this._selected_values)
			.uniqBy((opt) => opt.value)
			.find((opt) => opt.value === value);
		if (option) {
			if (this.values.includes(value)) {
				this._selected_values.push(option);
			} else {
				this._selected_values = this._selected_values.filter((opt) => opt.value !== value);
			}
		}
	}

	update_status() {
		let text;
		if (this.values.length === 0) {
			text = this.get_placeholder_text();
		} else if (this.values.length === 1) {
			let val = this.values[0];
			let option = this._options.find((opt) => opt.value === val);
			text = option ? option.label : val;
		} else {
			text = __("{0} values selected", [this.values.length]);
		}
		this.set_status(text);
	}

	get_placeholder_text() {
		return `<span class="text-extra-muted">${this.df.placeholder || ""}</span>`;
	}

	set_status(text) {
		this.$list_wrapper.find(".status-text").html(text);
	}

	process_options(options) {
		return options.map((option) => {
			if (typeof option === "string") {
				return {
					label: option,
					value: option,
					description: "",
				};
			}
			if (!option.label) {
				option.label = option.value;
			}
			return option;
		});
	}

	set_options() {
		let promise = Promise.resolve();
		if (this.df.get_data) {
			let txt = this.$filter_input.val();
			let value = this.df.get_data(txt);
			if (!value) {
				this._options = [];
			} else if (value.then) {
				promise = value.then((options) => {
					this._options = this.process_options(options);
				});
			} else {
				this._options = this.process_options(value);
			}
		} else {
			this._options = this.process_options(this.df.options);
		}
		return promise;
	}

	set_selectable_items(options) {
		let html = options
			.map((option) => {
				let encoded_value = encodeURIComponent(option.value);
				let selected = this.values.includes(option.value) ? "selected" : "";
				return `<li class="selectable-item ${selected}" data-value="${encoded_value}">
				<div>
					<strong>${option.label}</strong>
					<div class="small">${option.description}</div>
				</div>
				<div class="multiselect-check">${tuduno.utils.icon("tick", "xs")}</div>
			</li>`;
			})
			.join("");
		if (!html) {
			html = `<li class="text-muted">${__("No values to show")}</li>`;
		}
		this.$list_wrapper.find(".selectable-items").html(html);

		this.highlighted = -1;
	}

	get_value() {
		return this.values;
	}

	highlight_item(value) {
		this.highlighted += value;

		if (this.highlighted < 0) {
			this.highlighted = 0;
		}
		let $items = this.$list_wrapper.find(".selectable-item");
		if (this.highlighted > $items.length - 1) {
			this.highlighted = $items.length - 1;
		}

		let $item = $items[this.highlighted];

		if (this._$last_highlighted) {
			this._$last_highlighted.removeClass("highlighted");
		}
		this._$last_highlighted = $($item).addClass("highlighted");
		this.scroll_dropdown_if_needed($item);
	}

	scroll_dropdown_if_needed($item) {
		if ($item.scrollIntoView) {
			$item.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
		} else {
			$item.parentNode.scrollTop = $item.offsetTop - $item.parentNode.offsetTop;
		}
	}
};
